import { lazy, Suspense } from "react";
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/components/ThemeProvider";

// Eager load the homepage for fastest initial render
import Index from "./pages/Index";

// Lazy load other routes to reduce initial bundle size
const About = lazy(() => import("./pages/About"));
const Contact = lazy(() => import("./pages/Contact"));
const Coaching = lazy(() => import("./pages/services/Coaching"));
const Keynotes = lazy(() => import("./pages/services/Keynotes"));
const RapidResponse = lazy(() => import("./pages/services/RapidResponse"));
const Imprint = lazy(() => import("./pages/Imprint"));
const Privacy = lazy(() => import("./pages/Privacy"));
const NotFound = lazy(() => import("./pages/NotFound"));

// Minimal loading fallback that doesn't cause layout shift
const PageLoader = () => (
  <div className="min-h-screen bg-background" />
);

const App = () => (
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services/coaching" element={<Coaching />} />
            <Route path="/services/trainings" element={<Navigate to="/services/coaching" replace />} />
            <Route path="/services/keynotes" element={<Keynotes />} />
            <Route path="/services/rapid-response" element={<RapidResponse />} />
            <Route path="/imprint" element={<Imprint />} />
            <Route path="/privacy" element={<Privacy />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </TooltipProvider>
  </ThemeProvider>
);

export default App;
